// extracted by mini-css-extract-plugin
module.exports = {"ModalTab_tab":"ModalTab_ModalTab_tab__DAnso","isActive":"ModalTab_isActive__FYqsB","ModalTab_header":"ModalTab_ModalTab_header__fPPlk"};